<template>
  <div class="">
    <el-form class="demo-form-inline" :inline="true" size="mini" @submit.native.prevent>
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入名称" size="small" clearable @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" native-type="button" @click="handleSearch()">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        @selection-change="selectNews"
        ref="rfTable"
        style="width: 100%;"
        size="mini">
      <el-table-column v-if="type == 2"
         type="selection"
         align="center"
         width="55">
      </el-table-column>

      <el-table-column
          prop="user_id"
          label="会员ID"
          width="100">
      </el-table-column>
      <el-table-column
          prop="name"
          label="昵称"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="avatar"
          label="头像"
          align="center"
          width="160">
        <template slot-scope="scope">
          <el-avatar :size="40" shape="square" :src="scope.row.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
          prop="real_name"
          label="姓名"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="grade_name"
          label="会员卡"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="ftime"
          label="注册时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column v-if="type == 1"
         fixed="right"
         label="选择"
         align="center"
         width="100">
        <template slot-scope="scope">
          <el-button type="danger" size="small" @click="selectRow(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="changePage"
        layout="total, prev, pager, next"
        :page-size="search.limit"
        :total="search.total">
    </el-pagination>
    <el-button type="primary" size="small" @click="chooseOk()" style="position: absolute; bottom: 35px; left: 20px;" v-if="type == 2">确定</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: {
        current_page: 1,
        total: 0,
        limit: 5,
        keywords: ''
      },
      tableData: [],
      chooseList: []
    }
  },
  components: {},
  props: {
    selectFunc: Function,
    idx: Number,
    type: Number, // 1-单选，2-多选
    isGuider: Boolean
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  methods: {
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords,
        isGuider: that.isGuider?1:0
      }
      this.$api.member.memberIndex(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    changePage(page) {
      this.search.current_page = page
      this.getList()
    },
    selectRow(row) {
      this.selectFunc(row)
    },
    selectNews(data) {
      this.chooseList = data
    },
    // 多选操作
    chooseOk() {
      if (this.chooseList.length < 1) {
        this.fail('请选择会员')
      } else {
        this.selectFunc(this.chooseList)
      }
    }
  }
}
</script>

<style scoped>
</style>
